/* eslint-disable eslint-plugin/prefer-message-ids, eslint-plugin/require-meta-type, eslint-plugin/require-meta-schema, eslint-plugin/prefer-object-rule */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CollectionPointsElement from './Partials/CollectionPointsElement';
import CollectionPointsPopup from './Partials/CollectionPointsPopup';
import './CollectionPoints.scss';
import SearchIcon from './Icons/Search.png';
import CloseIcon from './Icons/x.png';
import ProviderManager from '../../../provider/providerManager';
import BackIcon from './Icons/Back.png';
import Image from 'app/Components/Shared/Image/image';
const COMPONENT_TYPE = {
  INTERNAL: 0,
  EXTERNAL: 1,
};

const CollectionPoints = (props) => {
  const dispatch = useDispatch();

  // קבלת subscriber מ-Redux (מתהליך ServiceAppointment)
  const subscriber = useSelector(
    (state) => state.serviceAppointmentSchedulerBlock?.subscriber
  );

  // subscriber מכיל: ban, subscriberNo (מספר טלפון), address, productDescription וכו'
  const ban = subscriber?.ban;
  const subscriberNo = subscriber?.subscriberNo;
  const commCode = useSelector(
    (state) => state.serviceAppointmentSchedulerBlock?.commCode
  );
  const blockId = props.iContent?.contentLink?.id;
  const subscriberPhone = useSelector(
    (state) => state.authentication?.loginData?.userDetails?.contactNumber
  );

  const [searchTerm, setSearchTerm] = useState('');
  const [cities, setCities] = useState(null);
  const [showCities, setShowCities] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [phoneNumber, setPhoneNumber] =     useState(subscriberPhone || '');

  // עדכון מספר טלפון כשמתקבל מ-Redux
  useEffect(() => {
    if (subscriberPhone) {
      setPhoneNumber(subscriberPhone);
    }
  }, [subscriberPhone]);

  useEffect(() => {
    if (searchTerm.length >= 2 && !selectedCity) {
      ProviderManager.getProviderData('getCitiesByValue', [searchTerm]).then((data) => {
        const results = /^\s*$/.test(searchTerm) ? null : data.Body;
        setCities(results);
        setShowCities(true);
      });
    } else {
      setCities(null);
      setShowCities(false);
    }
  }, [searchTerm, selectedCity]);

  // חישוב מרחק בין שתי נקודות (בק"מ) - נוסחת Haversine
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // רדיוס כדור הארץ בק"מ
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };


  const parseCoordinates = (coordString) => {
    if (!coordString) return null;
    const parts = coordString.split(',').map(s => parseFloat(s.trim()));
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      return { lat: parts[0], lon: parts[1] };
    }
    return null;
  };

  // מיון נקודות איסוף לפי מרחק מהעיר שנבחרה
  const sortedPoints = useMemo(() => {
    const points = props.iContent.pointsElements?.value || [];
    const normalizedSearchTerm = searchTerm.trim();

    if (!selectedCity) {
      if (normalizedSearchTerm.length < 2) {
        return points;
      }

      // אם לא נבחרה עיר, סנן לפי טקסט החיפוש
      return points.filter(point =>
        point.stationName?.includes(normalizedSearchTerm) ||
        point.cityAddress?.includes(normalizedSearchTerm) ||
        point.stationAddress?.includes(normalizedSearchTerm)
      );
    }

    const cityLat = parseFloat(selectedCity.lat);
    const cityLon = parseFloat(selectedCity.lon);

    return points
      .map(point => {
        const coords = parseCoordinates(point.coordinates);
        const distance = coords
          ? calculateDistance(cityLat, cityLon, coords.lat, coords.lon)
          : Infinity;
        return { ...point, distance };
      })
      .sort((a, b) => a.distance - b.distance);
  }, [props.iContent.pointsElements, selectedCity, searchTerm]);

  const handleSelectCity = (city) => {
    setSearchTerm(city.municipalname);
    setSelectedCity(city);
    setShowCities(false);
    setCities(null);
    console.log('Selected city:', city);
    console.log('Coordinates:', city.lat, city.lon);
  };

  const handleSelectPoint = (point) => {
    setSelectedPoint(point);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedPoint(null);
  };

  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
  };

  const handleSendSms = async () => {
    console.log('handleSendSms called', { selectedPoint, phoneNumber, ban, subscriberNo });

    if (!selectedPoint) {
      console.log('No selected point');
      return;
    }

    try {
      const pointCoordinates = parseCoordinates(selectedPoint.coordinates);
      await ProviderManager.getProviderData('routerActivationCreatePickUp', {
        ban,
        subscriberNumber: subscriberNo,
        commCode: commCode || '',
        blockId: blockId || '',
        lat: pointCoordinates?.lat?.toString() || '',
        lng: pointCoordinates?.lon?.toString() || '',
      });

      setShowPopup(false);
      dispatch({
        type: 'collectionPointsBlock/reportDWH',
        payload: {
          actionType: 'PickUp Order',
          status: 'Completed',
          messageText: 'Pickup message sent successfully',
          param1: 'PickUp'
        }
      });
      setShowConfirmPopup(true);

    } catch (error) {
      console.error('Error creating delivery order:', error);
      // בינתיים - עדיין נעבור להודעת אישור
      setShowPopup(false);
      setShowConfirmPopup(true);
    }
  };

  const handleNavigateToPoint = () => {
    if (selectedPoint?.coordinates) {
      const coords = selectedPoint.coordinates.split(',');
      const url = `https://waze.com/ul?ll=${coords[0]},${coords[1]}&navigate=yes`;
      window.open(url, '_blank');
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSelectedCity(null);
    setCities(null);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    window.history.back();
  };

  const isExternal = props.iContent.componentType?.value === COMPONENT_TYPE.EXTERNAL;

  return (
    <div className='CollectionPoints'>

      <div className='tabs-container'>
        {!isExternal && (
          <a href='#' className='back-button' onClick={handleBackClick}>
            <Image src={BackIcon} alt='icon' />
            חזרה
          </a>
        )}
        <div className='CollectionPointsTitle'>{props.iContent.title?.value || 'רשימת נקודות איסוף'}</div>
        <div className='CollectionPointsSubTitle'>{props.iContent.subTitle?.value || 'בכל נקודה מהרשימה ממתין לך ספק כוח חדש!'}</div>

        <div className='search-container'>
          {searchTerm.trim().length > 0 && (
            <Image src={CloseIcon} alt='clear' className='clear-search' onClick={clearSearch} />
          )}

          <input
            type='text'
            className='search-input'
            placeholder='חפשו לפי עיר'
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              if (selectedCity) setSelectedCity(null);
            }}
          />

          <Image src={SearchIcon} alt='search' className='search-icon' />

          {/* רשימת ערים */}
          {cities != null && showCities && (
            <div className='cities-dropdown'>
              <ul>
                {cities.map((city, index) => (
                  <li key={index} onClick={() => handleSelectCity(city)}>
                    {city.municipalname}
                  </li>
                ))}
                {cities.length === 0 && <li className='no-results'>לא נמצאו ערים</li>}
              </ul>
            </div>
          )}
        </div>

        <div className='CollectionPointsList'>
          {sortedPoints?.map((point, index) => (
            <CollectionPointsElement
              key={point.stationNumber || index}
              point={point}
              onSelect={handleSelectPoint}
              isExternal={isExternal}
            />
          ))}
        </div>
      </div>

      <CollectionPointsPopup
        isOpen={showPopup && selectedPoint}
        onClose={closePopup}
        type='SELECT_POINT'
        title={`${selectedPoint?.stationAddress || ''}, ${selectedPoint?.cityAddress || ''}\n${selectedPoint?.stationName || ''}`}
        onPrimaryClick={handleSendSms}
      />

      <CollectionPointsPopup
        isOpen={showConfirmPopup}
        onClose={closeConfirmPopup}
        type='CONFIRM_SMS'
        phoneNumber={phoneNumber}
        onWazeClick={handleNavigateToPoint}
        onSecondaryClick={closeConfirmPopup}
      />
    </div>
  );
};

export default CollectionPoints;
